import styled from 'styled-components';
import { TRANSITION } from '@shared/types/constants/animations';

const LanguageListWrapper = styled.div<React.CSSProperties>`
  transition: ${TRANSITION.LANGUAGE_ITEM};
`;

export default LanguageListWrapper;
